module.exports = __webpack_public_path__ + "static/media/swirl-left.79df1caa.png";